import { render, staticRenderFns } from "./MSDSTable.vue?vue&type=template&id=64138863&scoped=true"
import script from "./MSDSTable.vue?vue&type=script&lang=js"
export * from "./MSDSTable.vue?vue&type=script&lang=js"
import style0 from "./MSDSTable.vue?vue&type=style&index=0&id=64138863&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64138863",
  null
  
)

export default component.exports